import { render } from "./DeveloperPage.vue?vue&type=template&id=38872532"
import script from "./DeveloperPage.vue?vue&type=script&lang=js"
export * from "./DeveloperPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__